export default __webpack_public_path__ + "static/compareItemImg4-0f4644482de71a68f621bed180bb180d.webp";